<template>
  <div class="app">
    <div class="header" :class="{'relative': $route.name==='partner' || $route.name==='aboutus'||$route.name==='recruit'}"
    v-if="!($route.name==='seo'||$route.name==='confs')">
      <common-header pcMenuStyle='myhover' :loginUser="userInfo" :theme="isChangeNav?'white':'opacity'" :showMenu="isShowNav" :menu="menu">
        <a href="javascript:void(0)" slot="search" style="display:inline-block;padding:0">
          <search-PC @searchDisplay="searchDisplay"></search-PC>
        </a>
        <li slot="searchmobile">
          <search-mobile @searchDisplay="searchDisplay"></search-mobile>
        </li>
      </common-header>
    </div>
    <!-- site-main部分 -->
    <router-view></router-view>
    <!-- footer部分 -->
    <common-footer v-if="$route.name!=='service'&&$route.name!=='confs'"></common-footer>
    <!-- <transition name="fade" v-if="!isDataReady">
      <com-loader></com-loader>
    </transition> -->
  </div>
</template>

<script>
import myBus from './components/vueBus.js'
import utils from './util/WXshare.js'
import request from './util/request'
import CommonHeader from './components/common/header'
import CommonFooter from '@geekbang/geek.base/src/components/Footer'
import searchMobile from '@/components/search/mobile'
import searchPC from '@/components/search/pc'
import { mapMutations, mapState } from 'vuex'
// import comLoader from '@/components/com-loader'

export default {
  name: 'app',
  data () {
    return {
      scrollTop: 0,
      isShowNav: true,
      // scrollTop: true,
      isMobile: true,
      value: '',
      isDropdown: false,
      isChangeNav: false,
      // isDataReady: false,
      map: {
        video: true,
        home: false,
        conf: true,
        partner: true,
        aboutus: true,
        recruit: true
      }
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    searchPC,
    searchMobile
    // comLoader
  },

  created () {
    // ready
    // window.onload = function () {
    //   this.isDataReady = true
    //   console.log(this.isDataReady)
    // }
    this.entryUrl = window.location.href
    this.getDeviceSize()
    this.resizeWin()
    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    })
    this.isChangeNav = this.map[this.$route.name]
    this.initWxConfig()
    // 登录相关
    request.get('//account.geekbang.org/serv/v1/user/auth')
      .then((res) => {
        if (res.data.code === 0) {
          this.setUserInfo(res.data.data)
        }
      })
      .catch((e) => {
        // console.log(e)
      })
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.isChangeNav = this.map[val.name]
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.initWxConfig()
        }, 500)
      }
    }
  },

  methods: {
    ...mapMutations({
      setDevice: 'DEVICE_TYPE',
      setUserInfo: 'USER_INFO'
    }),
    // 登录
    login () {
      window.open('//account.geekbang.org/signin?redirect=' + encodeURIComponent(this.href))
    },
    // 退出登录
    logout () {
      // 改状态并通知
     this.setUserInfo({})
    },
    // 搜索按钮
    searchOn (value) {
      if (value && !this.isShowNav) {
        // 发起请求 并跳转页面
        // alert("对"+value+"发起请求")
        const url = 'http://s.geekbang.org/search/c=0/k=' + value + '/t='
        window.open(url)
        this.value = ''
      } else {
        // 把导航栏取消
        this.isShowNav = !this.isShowNav
      }
    },
    searchOff () {
      this.isShowNav = !this.isShowNav
    },
    searchDisplay () {
      this.isShowNav = !this.isShowNav
    },
    scroll () {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (!scrollTop) {
        // alert("2改变规则么？"+this.isChangeNav)
        this.scrollTop = !this.isChangeNav
        // alert("scroll2"+this.scrollTop)
      } else {
        this.scrollTop = false
        this.isShowNav = true
      }
    },

    // 窗口滚动事件
    navScroll () {
      window.addEventListener('scroll', this.scroll)
    },

    // 获取当前设备
    getDeviceSize () {
      let winWidth = 0
      if (window.innerWidth) {
        winWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        winWidth = document.body.clientWidth
      }
      this.isMobile = winWidth < 768
      this.setDevice(this.isMobile)
    },
    // 监听窗口改变
    resizeWin () {
      window.addEventListener('resize', () => {
        this.getDeviceSize()
        myBus.$emit('changeDevice', this.isMobile)
        // console.log(this.isMobile)
      })
    },

    dropSwither () {
      this.isDropdown = !this.isDropdown
      const body = document.querySelector('.app').parentNode
      const html = body.parentNode
      if (this.isDropdown) {
        body.classList.add('dropdown-fix')
        html.classList.add('dropdown-fix')
      } else {
        body.classList.remove('dropdown-fix')
        html.classList.remove('dropdown-fix')
      }
    },

    remainSearch () {
      this.isShowNav = !this.isShowNav
    },

    initWxConfig () {
      if (!utils.isInWeixin()) return
      const url = utils.isIOS() ? this.entryUrl : window.location.href
      this.$ajax.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=geekbang`).then(response => {
        const res = response.data
        if (res.code === 0 && res.data) {
          try {
            window.wx.config({
              debug: false,
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: String(res.data.timestamp), // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名，见附录1
              jsApiList: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          } catch (err) {
            // console.log(err)
          }
        }
      }, response => {
        // window.alert('请求出错了')
      })
    }
  },
  computed: {
    ...mapState(['userInfo']),
    isNavOpacity: function () {
      // console.log(this.isChangeNav)
      if (this.scrollTop === 0 && !this.isChangeNav) {
        return false
      } else {
        return true
      }
    },
    href () {
      return window.location.href
    },
    menu () {
      const menu = [
        { link: 'https://www.geekbang.org/', name: '首页' },
        { link: 'https://time.geekbang.org/', name: '极客时间' },
        { link: 'https://con.infoq.cn/conference/intro', name: '技术会议' },
        { link: 'https://www.infoq.cn', name: '技术媒体' },
        { link: 'https://tgo.geekbang.org', name: '高端会员' },
        { link: 'https://service.geekbang.org/?utm_source=geekbang&utm_medium=navbar', name: '团队学习' },
        { link: 'https://www.geekbang.org/partner', name: '合作伙伴' }
      ]
      return menu
    }
  },
  mounted () {}
}
</script>

<style lang="sass">
@import "./style/variable"
// @import './style/bulma/base/_all'
@import "./style/generic"
@import "./style/layout"
@import "./style/component"
@import "./style/icon/iconfont.css"

html,body
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important

.app
  .header
    position: absolute
    width: 100%
    z-index: 100
    &.relative
      position: relative

.fade-enter-active, .fade-leave-active
  transition: opacity 0.4s
.fade-enter, .fade-leave-to
  opacity: 0

</style>
